import { render, staticRenderFns } from "./leyo-dialog.vue?vue&type=template&id=06e28736"
import script from "./leyo-dialog.vue?vue&type=script&lang=js"
export * from "./leyo-dialog.vue?vue&type=script&lang=js"
import style0 from "./leyo-dialog.vue?vue&type=style&index=0&id=06e28736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_pwz6xkwfkuu76k24ttivynkur4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./leyo-dialog.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports